import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeEventService {
  private isDarkModeSubject = new BehaviorSubject<boolean>(false);
  isDarkMode$ = this.isDarkModeSubject.asObservable();

  toggleDarkMode(isDarkMode: boolean) {
    this.isDarkModeSubject.next(isDarkMode);
    /* alert(isDarkMode ? 'dark' : 'light'); */
  }
}